import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation, Inject, SecurityContext, isDevMode, Input, Output, EventEmitter} from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';

import {
  faCoffee,
  faLessThanEqual,
  faCopy,
  faExclamationTriangle,
  faFileUpload,
  faTimes,
  faCheck
} from '@fortawesome/free-solid-svg-icons';

import {
  KeycloakProfile
} from 'keycloak-js';
import {
  KeycloakService
} from 'keycloak-angular';
import {
  environment
} from '../../environments/environment';
import {
  THIS_EXPR
} from '@angular/compiler/src/output/output_ast';
import {
  SkipperService
} from '../services/skipper.service';
import {
  flatten,
  getHtmlTagDefinition
} from '@angular/compiler';
import { DomSanitizer } from '@angular/platform-browser';
import kjua from 'kjua';
import { formatDate } from '@angular/common';


interface Tipo {
  name: String,
  code: String
}
interface Juzgado {
  name: String,
  code: String,
  descripcion: String
}

interface Vencimiento {
  name: String,
  code: number
}

interface trayItem {
  date;
  size;
  fileName;
  shortId;
  fileType;
}

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
  encapsulation: ViewEncapsulation.None
})


export class EditComponent implements AfterViewInit, OnInit {

  userDetails: KeycloakProfile;
  sessionToken = ''
  @Input('currentEntity')
  inputCurrentEntity: any;

  @Output()
  onDialog = new EventEmitter<boolean>();

  //files = []
  faCoffee = faCoffee; faExclamationTriangle = faExclamationTriangle;
  faCopy = faCopy; faCheck = faCheck; 
  faFileUpload = faFileUpload;
  faTimes = faTimes;
  showProgressBar = false;
  showSaveButton = true;
  barProgress = 0
  isFinished = false
  warnings=[]
  rateRelevancia = 0
  val: number = 3;

  shortId = '';
  descripcion='';
  selectedCondicion: string;
  lastKBytes = 0;
  lastNow = new Date().getTime();
  speed = ''
  showBrowseFiles = true
  response_link = undefined
  confirmCopied = false
  warns = []
  final_report;
  all_verified = false
  hideIndividualQR = false
  group_id = ''
  group_prefix = ''
  juzgadosFilterDrop: Juzgado[] = []
  stay = true
  elementType = 'url';
  juzgadosLoading = false
  html_report = ''
  userConfigMissing = false
  NO_META4_USER = environment.NO_META4_USER_MESSAGE

  vence: boolean = undefined;
  idEntity: string = '';
  dpdnJuzgados: Juzgado[] = [];
  dpdnJuzgadoSelected: Juzgado = undefined;
  dpdnTipos: Tipo[] = [];
  dpdnTipoSelected: Tipo = undefined;
  dpdnVencimientos: Vencimiento[] = [];
  dpdnVencimientoSelected: Vencimiento = undefined;
  inputCantidadDias: number = 0;
  inputTextNumeroExpediente: string = '';
  inputIdJuzgado: string = '';
  inputIdTipoActo: string = '';
  inputTextVisibilidad: string = '';
  inputTextDescripcion: string = '';
  inputRelevancia: number = 3;
  inputFechaVencimiento: string = '';
  fechaVencimientoActual: string = '';
  diaHoy = new Date().getUTCDate();
  mesHoy = new Date().getUTCMonth() + 1;
  anoHoy = new Date().getFullYear();
  fechaHoy: string = '';
  fechaDesde: number = 0;
  fechaHasta: number = 0;
  dia: string = '';
  mes: string = '';

  disableComponents: boolean = true;
  btnSaveLabel: string = 'Guardar'
  btnSaveClass: string = 'p-button-primary'
  showProgressSpinner: boolean = false;

  @ViewChild('input') input: ElementRef;
  @ViewChild('bar') bar: ElementRef;
  // @ViewChild('ourForm', {static: true}) ourForm;
  ngAfterViewInit() {
    if (isDevMode()) console.log(this.input.nativeElement.innerHTML);
  }

  constructor(private keycloakService: KeycloakService,
    private skipperService: SkipperService,
    private changeDetection: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) { }

  async doLogout() {
    await this.keycloakService.logout();
  }

  async ngOnInit() {

    if (await this.keycloakService.isLoggedIn()) {
      if (isDevMode()) console.log("logged in!!");
      this.userDetails = await this.keycloakService.loadUserProfile();
      if (isDevMode()) console.log(this.userDetails['username'])
      this.sessionToken = await this.keycloakService.getToken();
      this.skipperService.getUsuarios().subscribe(r => {
        if (r['error_code'] != undefined && r['error_code'] == 'err-06') {
          this.userConfigMissing = true

        }
      })
    }
    localStorage.setItem("isFinished", "false")

    this.clearComponents();
    this.loadEntity();
  }


  clearComponents() {
    this.dpdnJuzgadoSelected = undefined;
    this.dpdnTipoSelected = undefined;
    this.dpdnVencimientoSelected = undefined;
    this.inputTextNumeroExpediente = '';
    this.selectedCondicion = '';
    this.inputTextDescripcion = '';
    this.val = 1;
    this.inputFechaVencimiento = '';
    this.vence = undefined;
    //this.fechaVencimientoActual = '';
  }

  loadEntity() {
    this.disableComponents = false;
    this.idEntity = this.inputCurrentEntity.id;
    this.inputIdTipoActo = this.inputCurrentEntity.tipo_acto;
    this.inputTextNumeroExpediente = this.inputCurrentEntity.numero_expediente;
    this.selectedCondicion = this.inputCurrentEntity.condicion;
    this.inputIdJuzgado = this.inputCurrentEntity.id_juzgado;
    this.inputTextDescripcion = this.inputCurrentEntity.descripcion;
    this.val = this.inputCurrentEntity.relevancia;
    this.inputFechaVencimiento = this.inputCurrentEntity.fecha_vencimiento;
    this.vence = this.inputCurrentEntity.vencimiento;
    this.shortId = this.inputCurrentEntity.short_id;
    
    // si el documento posee fecha de vencimiento, calculo la cantidad_dias

    if (this.inputFechaVencimiento){
      if (this.mesHoy < 10){
        this.mes = '0' + this.mesHoy.toString();
      } else {
        this.mes = this.mesHoy.toString();
      }

      if (this.diaHoy < 10){
        this.dia = '0' + this.diaHoy.toString();
      } else {
        this.dia = this.diaHoy.toString();
      }
      
      this.fechaHoy = this.anoHoy.toString() + '-' +  this.mes + '-' + this.dia;
      this.fechaVencimientoActual = formatDate(new Date(this.inputCurrentEntity.fecha_vencimiento),'yyyy-MM-dd','en-US');

      this.fechaHasta = new Date(this.fechaVencimientoActual).getTime();
      this.fechaDesde = new Date(this.fechaHoy).getTime();
      this.inputCantidadDias = (this.fechaHasta - this.fechaDesde)/(1000*60*60*24);
    } else {
      this.inputCantidadDias = -1;
    }    
    
    this.juzgadosLoading = true
    
    this.skipperService.getJuzgados().subscribe(r => {
      let tarr = []
      for (let a = 0; a < r['data'].length; a++) {
        tarr.push({ "name": r['data'][a]['cod_nomenclador'] + '-' + r['data'][a]['descripcion'], "code": r['data'][a]['id'], "cod_nomenclador": r['data'][a]['cod_nomenclador'], "descripcion": r['data'][a]['descripcion'] });
      }
      this.juzgadosLoading = false
      this.dpdnJuzgados = tarr
      this.dpdnJuzgadoSelected = this.dpdnJuzgados.find(x => x.code == this.inputIdJuzgado); 
    })
    
    this.skipperService.getTiposActos().subscribe(r => {
      let tarr = []
      for (let a = 0; a < r['data'].length; a++) {
        tarr.push({ "name": r['data'][a]['descripcion'], "code": r['data'][a]['id'], "cod_nomenclador": r['data'][a]['cod_nomenclador'] });
      }
      this.dpdnTipos = tarr
      this.dpdnTipoSelected = this.dpdnTipos.find(x => x.name == this.inputIdTipoActo); 
    })
    
    this.dpdnVencimientos= [
        { name: "No modificar", code: 0 },
        { name: "Sin plazo", code: -1 },
        { name: "  7 días (una semana)", code: 7 },
        { name: " 30 días (un mes)", code: 30 },
        { name: " 60 días (dos meses)", code: 60 },
        { name: "365 días (un año)", code: 365 },
        { name: "730 días (dos años)", code: 730 }
    ]
    this.dpdnVencimientoSelected = this.dpdnVencimientos.find(x => x.name == "No modificar")    
    
    //this.fecha_guardado = 'Creado: ' + formatDate(new Date(this.inputCurrentEntity.fecha_guardado),'dd-MM-yyyy HH:mm','en-US', '+0000');
    
    //if (this.inputCurrentEntity.fecha_creacion !== this.inputCurrentEntity.fecha_actualizacion) {

      //  this.fechaActualizacion = 'Última actualización: ' + formatDate(new Date(this.inputCurrentEntity.fecha_actualizacion),'dd-MM-yyyy HH:mm','en-US', '+0000');
      //}
      
    }


  validateFieldsBeforeSave() {
    this.warnings = []
    let missings = []
    if (this.selectedCondicion == undefined) {
      missings.push('condicion');
    }
    if (this.dpdnTipoSelected == undefined) {
      missings.push('tipo');
    }
    if (!this.dpdnJuzgados.includes(this.dpdnJuzgadoSelected)) { 
      missings.push('juzgado')
    }
    //if(this.numeroExpediente=='' || this.numeroExpediente.length<2) missings.push('expediente');
    // if (missings != []) this.warnings = missings;
    return missings.length == 0
  }


  save() {   
    if(this.validateFieldsBeforeSave()) {
      this.showSaveButton = false;
      this.showProgressBar = true;
      var formData = new FormData();
      this.group_id='';
      this.group_prefix='';

      // si selecciona 'Sin vencimiento' --> vencimiento es false;
      
      if (this.dpdnVencimientoSelected.code === -1){    
        this.vence = false
      }
      
      // si selecciona 'No modificar' --> la cantidadDias no se modifica.
      if (this.dpdnVencimientoSelected.code > 0){    
        this.inputCantidadDias = this.dpdnVencimientoSelected.code
        this.vence = true
      }
        
      let metaObj = {
        "short_id": this.shortId,
        "id_tipo_acto": this.dpdnTipoSelected.code,
        "id_juzgado": this.dpdnJuzgadoSelected.code,
        "descripcion_juzgado":this.dpdnJuzgadoSelected.descripcion,
        "numero_expediente": this.inputTextNumeroExpediente,
        "relevancia": this.val,
        "condicion": this.selectedCondicion,
        "descripcion": this.inputTextDescripcion,
        "descripcion_tipo_acto": this.dpdnTipoSelected.name,
        "cantidad_dias": this.inputCantidadDias,
        "vencimiento": this.vence
      }    

      formData.append("tenant", "cpl");   
      //formData.append("url_for_validate", "localhost:2343"); // number 123456 is immediately converted to a string "123456"
      
      formData.append("metadata", JSON.stringify(metaObj));

      // use our custom AJAX function
      this.saveAsync(environment.BACK_EDITAR, 'PUT', formData ,this.sessionToken);     
    } else {
      //some toast here
    }
    this.onDialog.emit(false);
  }

  saveAsync = (url, method, data, token) => {
    return new Promise(function (resolve, reject) {
      let request = new XMLHttpRequest();
      request.responseType = 'json';    
      if (request.readyState === XMLHttpRequest.DONE) {
          if (request.status === 200) {
            resolve(request.response);
          } else {
            reject("Error(request.status)");
          }
      };
      request.onerror = function () {
        reject(Error("Network Error"));
      };
      request.open(method, url, true);
      request.setRequestHeader('Authorization', 'Bearer ' + token)
      request.send(data);
    });
  }


  closeSession() {
    this.skipperService.closeSession()
  }


}



